/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const OrganisationsApiEnum = {
    POST_ORGANISATIONS_INVITE: (id: string): string => {
        return '/organisations/' + id;
    },
    GET_ORGANISATIONS_MEMBERS: (id: string): string => {
        return '/organisations/' + id + '/members';
    },
    GET_ORGANISATIONS_MEMBERS_BY_ID: (id: string, userId: string): string => {
        return '/organisations/' + id + '/members/' + userId;
    },
    DELETE_MEMBER_ASSOCIATION: (id: string, userId: string): string => {
        return `/organisations/${id}/${userId}`;
    },
    POST_ORGANISATIONS_ADD: '/organisations/',
    GET_ORGANISATIONS: (id: string): string => {
        return '/organisations/' + id;
    },
    PATCH_ORGANISATIONS_UPDATE: (id: string): string => {
        return '/organisations/' + id;
    },
    DELETE_ORGANISATIONS: (id: string): string => {
        return '/organisations/' + id;
    },
    POST_ORGANISATION_SAML: (id: string): string => {
        return `/organisations/${id}/saml`;
    },
    DELETE_ORGANISATION_SAML: (id: string): string => {
        return `/organisations/${id}/saml`;
    },
    GET_ORGANISATIONS_ACCOUNT_BY_ID: (id: string, userId: string): string => {
        return '/organisations/' + id + '/accounts/' + userId;
    },
    PATCH_ORGANISATIONS_ACCOUNT_BY_ID: (id: string, userId: string): string => {
        return '/organisations/' + id + '/accounts/' + userId;
    },
};
